<template>
  <div>
    <button
      type="button"
      @click="toggle"
      class="p-button p-component p-button-text-icon-right"
    >
      <span class="pi pi-external-link p-button-icon-right"></span
      ><span class="p-button-text p-c">Ansicht in Vollbild</span>
    </button>
    <div class="example">
      <Belegungsplan :studioBezeichner="'darmstadt'" :datum="heute" :fullscreen="fullscreen" :zufaellig="true" />
    </div>
  </div>
</template>
<script>
import fullscreen from "vue-fullscreen";
import Vue from "vue";
import { currentTimestamp } from '@/api/Termine';
Vue.use(fullscreen);
export default {
  computed: {
    heute: () => currentTimestamp().format(),
  },
  methods: {
    toggle() {
      this.$fullscreen.toggle(this.$el.querySelector(".example"), {
        wrap: true,
        callback: this.fullscreenChange,
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
  },
  data() {
    return {
      fullscreen: false,
    };
  },
};
</script>
